export enum OfferTextModuleProductTypeEnum {
    HARDWARE,
    SUPPLY
}
